module.exports = __webpack_public_path__ + "assets/ic_camera2.42a7be9b.svg";